import React, {useEffect} from 'react';
import { Heading2 } from '../../../../libs/uiKit/globalStyledComponents';
import Button from '../../../../libs/uiKit/button';
import {PrecalculationForm, usePrecalculationContext} from './context';
import {
    NewStyledBankCardsWrapper,
    StyledHr,
    StyledPrecalculationFormCard,
} from './styles';
import {TextButton12} from "../../../../libs/uiKit/globalStyles";
import {
    StyledCircle,
    StyledRadioBox,
    StyledRadioInput,
    StyledRadioItemsWrapper, StyledRadioWrapper
} from "../../../../libs/uiKit/radio/styles";
import {useGlobalContext} from "../../../../apps/main/ui/GlobalContext";
import DeclarationTextModal from "./DeclarationTextModal";
import ResultItem from "./ResultItem";

const Result: React.FC = () => {
	const {
        isLoading,
        selectBankHandler,
        resultItems,
        isDisabledSelectBank,
        isDataChanged,
        recalcForm,
        formHook,
        keepOnlyOneBank,
        discountKv,
        setDiscountKv,
        discountSk,
        setDiscountSk,
        promocode,
        setPromocode,
        fixedDiscount,
        stateContinueType,
        setStateContinueType,
        precalculationFormData,
    } =
		usePrecalculationContext();

    const { user : { isStaffMember } } = useGlobalContext();

    const agentIsn = formHook.watch('agentIsn');

    const showDiscountKv = !isStaffMember || isStaffMember && !!agentIsn;

    useEffect(() => {
        if(!showDiscountKv && discountKv){
            setDiscountKv("");
        }
    }, [showDiscountKv]);

    const [isDeclarationTextModalOpen, setIsDeclarationTextModalOpen] = React.useState(false);

	if (resultItems.length === 0) return null;

    const isSelected = resultItems.length === 1;

    const hasLife = precalculationFormData?.life || false;
    const hasProperty = precalculationFormData?.property || false;

    const needOms = resultItems.some((item) =>
        item.risks.some((risk) =>
            risk.borrowers.some((borrower) => borrower?.needOms )
        )
    );

	return (
		<StyledPrecalculationFormCard>
			<Heading2>&nbsp;</Heading2>

			<NewStyledBankCardsWrapper>
				{resultItems.map(({ isn, isnBank, name, sum, premium, logo, risks, isExpress, noExpressReason, crossId, warning, allowDiscount, oldPremium, resultDiscount }) => (
                    <ResultItem
                        isSelected={isSelected}
                        isn={isn}
                        isnBank={isnBank}
                        name={name}
                        sum={sum}
                        premium={premium}
                        logo={logo}
                        risks={risks}
                        warning={warning}
                        needOms={needOms}
                        fixedDiscount={resultDiscount}
                        promocode={promocode}
                        setPromocode={setPromocode}
                        showDiscountKv={showDiscountKv}
                        discountBlockAllowed={allowDiscount}
                        setDiscountKv={setDiscountKv}
                        discountKv={discountKv}
                        setDiscountSk={setDiscountSk}
                        discountSk={discountSk}
                        isDataChanged={isDataChanged}
                        inputsDisabled={false}
                        oldPremium={oldPremium}
                        buttonsNode={<>
                            {isSelected && !isDataChanged &&
                                <>
                                    {isExpress &&
                                        <>
                                            <StyledHr/>

                                            <br/>
                                            <StyledRadioWrapper>
                                                <StyledRadioItemsWrapper template="1fr">
                                                    <StyledRadioBox key='radio-1' isDisabled={false} isInvalid={false}>
                                                        <StyledRadioInput
                                                            name='continueType'
                                                            type='radio'
                                                            value='declaration'
                                                            onClick={(): void => setStateContinueType('declaration')}
                                                            checked={stateContinueType === 'declaration'}
                                                        />
                                                        <StyledCircle />
                                                        <TextButton12>
                                                            Оформить
                                                            <Button
                                                                appearance="blacklink"
                                                                onClick={(): void => setIsDeclarationTextModalOpen(true)}
                                                                textFontSize="1.2rem"
                                                                style={{display: "inline-block", padding: "0", marginLeft: "0.5rem"}}
                                                            >
                                                                на условиях декларации
                                                            </Button>
                                                        </TextButton12>
                                                    </StyledRadioBox>
                                                    <StyledRadioBox key='radio-2' isDisabled={false} isInvalid={false}>
                                                        <StyledRadioInput
                                                            name='continueType'
                                                            type='radio'
                                                            value='anketa'
                                                            onClick={(): void => setStateContinueType('anketa')}
                                                        />
                                                        <StyledCircle />
                                                        <TextButton12>Оформить на основании анкеты</TextButton12>
                                                    </StyledRadioBox>
                                                </StyledRadioItemsWrapper>
                                            </StyledRadioWrapper>
                                        </>
                                    }

                                    <Button
                                        isDisabled={isDisabledSelectBank || !stateContinueType && isExpress}
                                        isLoading={isLoading}
                                        onClick={(): void => selectBankHandler(isnBank, stateContinueType === 'declaration', crossId)}
                                        appearance='filled'
                                        textFontSize="1.6rem"
                                    >
                                        Оформить
                                    </Button>
                                </>}
                            {!isSelected && !isDataChanged &&
                                <>
                                    <br/>
                                    <br/>
                                    <Button appearance='lightblue' onClick={() => keepOnlyOneBank(isnBank)}>Выбрать</Button>
                                </>
                            }
                            {isDataChanged &&
                                <>
                                    <br/>
                                    <br/>
                                    <Button appearance='lightblue' isLoading={isLoading} onClick={() => {
                                        formHook?.trigger().then((isValid: boolean) => {
                                            if (isValid) {
                                                const formData = formHook.getValues() as PrecalculationForm;
                                                recalcForm(formData);
                                            }
                                        });
                                    }}>Пересчитать</Button>
                                </>
                            }
                    </>}
                    />
				))}
			</NewStyledBankCardsWrapper>
            <DeclarationTextModal onClose={(): void => setIsDeclarationTextModalOpen(false)} isOpen={isDeclarationTextModalOpen} life={hasLife} property={hasProperty} />
		</StyledPrecalculationFormCard>
	);
};

export default React.memo(Result);
